Ext.define('SA.AcsTable.DefaultViewState', {
    constructor({model, projectView, tableData, folderData}) {
        this.model = model;
        this.projectView = projectView;
        this.tableData = tableData;
        this.folderData = folderData;
    },

    getAttributes() {
        return this.hasFolderId() ? this.folderData.get({folderId: this.getFolderId()}) : [];
    },

    getCensusReleaseYear() {
        return this.model.getState().getCensusReleaseYear();
    },

    getDataMapParams() {
        var attributes = this.getAttributes().map(attribute => attribute.getId()),
            locations = this.getLocations().map(location => location.toNormalized());

        return {attributes, locations};
    },

    getEdition() {
        return this.model.getState().getEdition();
    },

    getFolderId() {
        return this.getTableFolders().find(({id}) => id === this.getTableId())?.folderId;
    },

    getGridContainerSize() {
        var width = this.projectView.getWidth() - 2, 
            height = this.projectView.getHeight() - 2; 

        return {width, height};
    },

    getGridTrackIds() {
        var colIds = this.getLocations().map(location => location.getStringId()),
            rowIds = this.getAttributes().filter(attribute => !attribute.hasPercentType()).map(attribute => attribute.getId());

        return SA.view.TableTrackIds.create({colIds, rowIds});
    },

    getLocations() {
        return this.model.getState().getSelectedLocations();
    },

    getTableFolders() {
        return this.tableData.get({censusReleaseYear: this.getCensusReleaseYear(), edition: this.getEdition()});
    },

    getTableId() {
        return this.model.getState().getTableId();
    },

    hasAttributes() {
        return this.getAttributes().length > 0;
    },

    hasFolderId() {
        return this.getFolderId() != null;
    },

    tableFoldersLoaded() {
        return this.getTableFolders().length > 0;
    }
});